// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { MediaRequestStatuses } from "./Shared.Models.Api.V1.MediaRequestStatuses.gen";
import { MediaRequestSource } from "./Shared.MediaRequestSource.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { DateBefore } from './validators';
import { IsNotEmpty, IsOptional } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IDeviceMediaRequest {
	id: string | undefined;

	deviceId: string;

	includeRadarData: boolean | undefined;

	periodStart: string | undefined;

	periodEnd: string | undefined;

	requestDate: string | undefined;

	status: MediaRequestStatuses;

	requestedById: string | undefined;

	mediaRequestSource: MediaRequestSource;

	videoUrl: string | undefined;

	radarUrl: string | undefined;

	supportFilesUrl: string | undefined;

	progress: number;

	message: string | undefined;

	bytesPerSecond: number | undefined;

	statusStart: string | undefined;

	desiredBps: number | undefined;

	desiredFps: number | undefined;

	desiredWidth: number | undefined;

	desiredHeight: number | undefined;

	includeVideo: boolean | undefined;

	radarDataStart: string | undefined;

	videoDataStart: string | undefined;

	videoDataEnd: string | undefined;

	expireDate: string | undefined;

	eventId: string | undefined;

	notices: string | undefined;

	$type?: string | undefined;
}
export class DeviceMediaRequest {
	constructor(data?: IDeviceMediaRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.periodStart) { this.periodStart = new Date(data.periodStart); }
		if (data.periodEnd) { this.periodEnd = new Date(data.periodEnd); }
		if (data.requestDate) { this.requestDate = new Date(data.requestDate); }
		if (data.statusStart) { this.statusStart = new Date(data.statusStart); }
		if (data.radarDataStart) { this.radarDataStart = new Date(data.radarDataStart); }
		if (data.videoDataStart) { this.videoDataStart = new Date(data.videoDataStart); }
		if (data.videoDataEnd) { this.videoDataEnd = new Date(data.videoDataEnd); }
		if (data.expireDate) { this.expireDate = new Date(data.expireDate); }
	}

	id: string | undefined;

	@IsNotEmpty()
	deviceId: string = "";

	includeRadarData: boolean | undefined;

	@IsOptional()
	@DateBefore("periodEnd", {
	  "message": "Start time must be before the end time."
	})
	periodStart: Date | undefined = new Date();

	periodEnd: Date | undefined = new Date();

	requestDate: Date | undefined = new Date();

	status: MediaRequestStatuses = 0;

	requestedById: string | undefined;

	mediaRequestSource: MediaRequestSource = 0;

	videoUrl: string | undefined;

	radarUrl: string | undefined;

	supportFilesUrl: string | undefined;

	progress: number = 0;

	message: string | undefined;

	bytesPerSecond: number | undefined;

	statusStart: Date | undefined;

	desiredBps: number | undefined;

	desiredFps: number | undefined;

	desiredWidth: number | undefined;

	desiredHeight: number | undefined;

	includeVideo: boolean | undefined;

	radarDataStart: Date | undefined;

	videoDataStart: Date | undefined;

	videoDataEnd: Date | undefined;

	expireDate: Date | undefined = new Date();

	eventId: string | undefined;

	notices: string | undefined;

	static $type: string = "CoreApi.Models.DeviceMediaRequest, ";
	$type?: string | undefined = DeviceMediaRequest.$type;
}

